import React, { Fragment } from 'react';

const VehicleAvailableSF = () => (
  <Fragment>
    <p>
      At Autzu, we offer the sleek and high-performing Tesla Model 3 in
      both Long Range and Standard Range options. Our vehicles are
      automatically assigned for you based on fleet availability. While you
      may not be able to select a specific vehicle, rest assured that all
      of our vehicles are top-quality and well-maintained for your
      enjoyment.
    </p>
    <br />
  </Fragment>
);

export default VehicleAvailableSF;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/VehiclesAvailableSF.js